import { ServiceAppointmentAttachmentInput } from '../request-models/service-appointment-attachment-input.model';
import { ServiceAppointmentCreate } from '../request-models/service-appointment-create.model';
import { ServiceAppointmentListQuery } from '../request-models/service-appointment-list-query.model';
import { QueryParams } from '../../abstract/query-params';
import { omitUndefined } from './wire-value-utils';

/** The create body with only the fields that are set; attachments are copied field by field. */
export function toServiceAppointmentRequest(input: ServiceAppointmentCreate): ServiceAppointmentCreate {
  return omitUndefined<ServiceAppointmentCreate>({
    organizationId: input.organizationId,
    droneId: input.droneId,
    preferredDate: input.preferredDate,
    preferredTime: input.preferredTime,
    issueDescription: input.issueDescription,
    attachments: input.attachments?.map(toAttachmentInput),
  });
}

/** List query params; unset filters are dropped by the base. */
export function toServiceAppointmentListQuery(query: ServiceAppointmentListQuery = {}): QueryParams {
  return { status: query.status, page: query.page, limit: query.limit };
}

function toAttachmentInput(input: ServiceAppointmentAttachmentInput): ServiceAppointmentAttachmentInput {
  return omitUndefined<ServiceAppointmentAttachmentInput>({
    fileName: input.fileName,
    fileSize: input.fileSize,
    fileType: input.fileType,
    fileExtension: input.fileExtension,
    s3Key: input.s3Key,
    s3Url: input.s3Url,
    cdnUrl: input.cdnUrl,
  });
}
